import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import LibraryProceduresGrid from './LibraryProceduresGrid';

const LibraryProceduresGridBridge = react2angular(LibraryProceduresGrid, []);

export default LibraryProceduresGridBridge;
